// Module
var code = "<div> <div item=\"vm.tag\" template=\"tagPopover.html\" wt-popover> <a ng-class=\"{'disabled':vm.isEditMode}\" ui-sref=\"tag.general({tagDefinitionGuid:vm.tag.guid, tag:vm.tag})\"> <span>{{vm.tag.name}}</span> </a> </div> </div>";
// Exports
module.exports = code;